import { programConfig } from "./program-config";
import { sportIds } from "./sport-types";
import { webPushApiUrl } from "./base-urls";

const getItemValueByKey = ({ category, sportName, marketName, key }) => {
    return marketName ? programConfig[category][sportName][marketName][key] : programConfig[category][sportName][key];
};

export const LIVE = "live";
export const LIVE_MIXED = "mixed";
export const FIXTURE = "upcoming/matches";
export const LIVE_RESULTS = "live/results";

export const WEB_PUSH = `${webPushApiUrl}/live_info`;
export const WEB_PUSH_SOCCER = `${webPushApiUrl}/live_soccer`;
export const WEB_PUSH_BASKETBALL = `${webPushApiUrl}/live_basketball`;

export const LIVE_PARAMS = (sportId, marketName, currentPage, matchTimeRange, pinnedEventIds) => {

    const category = "live";

    let marketGroupId = getItemValueByKey({
        category: category,
        sportName: sportIds[sportId],
        marketName: marketName,
        key: "marketGroupId"
    });

    const limit = getItemValueByKey({
        category: category,
        sportName: sportIds[sportId],
        marketName: marketName,
        key: "limit"
    });

    return {
        "sportId": sportId,
        "screen": marketGroupId,
        "limit": limit,
        "page": currentPage,
        "hour": matchTimeRange,
        "eventIds": pinnedEventIds
    };

};

export const LIVE_MIXED_PARAMS = (sportId, currentPage, pinnedEventIds) => {

    return {
        "sportId": sportId,
        "limit": 3,
        "page": currentPage,
        "eventIds": pinnedEventIds,
        "screen": 1
    };

};

export const FIXTURE_PARAMS = (sportId, marketName, currentPage, matchTimeRange, pinnedEventIds, isKingBet) => {

    const limit = getItemValueByKey({
        category: "fixture",
        sportName: sportIds[sportId],
        marketName: marketName,
        key: "limit"
    });

    return {
        "sportId": sportId,
        "limit": limit,
        "page": currentPage,
        "hour": matchTimeRange,
        "eventIds": pinnedEventIds,
        "isKingBet": isKingBet
    };

};

export const LIVE_RESULTS_PARAMS = (currentPage, limit, pinnedEventIds) => {
    return {
        page: currentPage,
        limit: limit,
        eventIds: pinnedEventIds
    };
};

export const MATCH_RESULTS = (date, currentPage, matchTimeRange) => `match/result?date=${date}&page=${currentPage}&hour=${matchTimeRange}`;

export const MULTI_SCREEN = currentPage => `/multi/screen?page=${currentPage}`;

export const LIVE_MATCH_DETAIL_SCREEN = (sportId, eventId, screen, isStream) => `match/detail/${sportId}/${eventId}?screen=${screen}&isStream=${isStream}`;
export const LIVE_MATCH_DETAIL = (sportId, eventId, isStream) => `match/detail/${sportId}/${eventId}?isStream=${isStream}`;

export const AUTH_PROCESS_ROOT = "/Auth"
export const LOGIN_SIGNIN = `/Auth/sign-in`;
export const LOGIN_FORGETPASSWORD = `/Auth/forgot-password`;
export const LOGIN_CODE_VALID = `/Auth/code-valid-control`;
export const LOGIN_RESET_PASSWORD = `/Auth/reset-password`;

export const RANDOM_MATCH = `/match/random`;

export const ANALYTICS_LOGIN = `/analytics/login`;
export const ANALYTICS_LOGOUT = `/analytics/logout`;
